<template>
	<div class="item-form">
		<el-form :model="form" :inline="true" :disabled="disabled">
			<div v-for="(item, index) in form.data" :key="item.id">
				<el-form-item label="客户类型" required>
					<el-select v-model="form.data[index].userTypeId" @change="handleUserTypeChange">
						<el-option
							v-for="option in userTypeOptions"
							:key="option.value"
							:label="option.label"
							:value="option.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="showComparison" :label="comparison.comparisonName" required>
					<el-input
						v-model="form.data[index].comparisonValue"
						type="number"
						:min="0"
						:step="1"
						@change="handleTimeChange"
					>
						<template v-if="!!comparison.comparisonUnit" #suffix>
							<span>{{ comparison.comparisonUnit }}</span>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="报警等级">
					<el-select v-model="form.data[index].eventLevel" @change="handleChange">
						<el-option
							v-for="option in alarmLevelOptions"
							:key="option.value"
							:label="option.label"
							:value="option.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<div class="operation-wapper" :class="disabled ? 'disabled' : ''">
						<img
							class="operate-icon"
							src="@/assets/imgs/alarm-water/common-alarm/add.svg"
							alt=""
							@click="handleAddClick"
						/>
						<img
							class="operate-icon"
							src="@/assets/imgs/alarm-water/common-alarm/delete.svg"
							alt=""
							@click="handleDeleteClick(item.selfId)"
						/>
					</div>
				</el-form-item>
			</div>
		</el-form>
	</div>
</template>

<script>
import { isValidate } from '@/utils/validate'
import { conditionalOptionObj } from '@/config/validate'

const USER_TYPE_ALL = { label: '全部', value: '0' }
// 表单备份值，用于客户类型重复时回退
let backupData = []

export default {
	name: 'ItemForm',
	inject: ['getComparison'],
	model: {
		prop: 'modelValue',
		event: 'update:modelValue',
	},
	props: {
		modelValue: {
			type: Array,
			default: () => [],
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		eventExpression: {
			type: String,
			default: '',
		},
		showComparison: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			// 作为动态表单项的唯一标识
			selfId: 0,
			// 表单数据
			form: { data: [] },
			userTypeOptions: [],
			alarmLevelOptions: [],
		}
	},
	computed: {
		timeVerificationRule() {
			const obj = JSON.parse(this.eventExpression)
			return {
				type: obj.conditionalStatementId,
				value: Number(obj.comparisonValue),
			}
		},

		comparison() {
			return this.getComparison()
		},
	},
	mounted() {
		this.userTypeOptions = [USER_TYPE_ALL, ...this.extractList(this.$store.getters.dataList.userType)]
		this.alarmLevelOptions = this.extractList(this.$store.getters.dataList.alarmLevel)
	},
	watch: {
		modelValue: {
			handler(val) {
				const newData = this.initFormData(JSON.parse(JSON.stringify(val.length > 0 ? val : [{}])))
				this.backUpData(newData)
				this.form = { data: newData }
			},
		},
	},
	methods: {
		handleUserTypeChange() {
			if (!this.isUserTypeRepeat(this.form.data)) {
				this.$message.warning('客户类型不允许重复')
				this.form.data = JSON.parse(JSON.stringify(backupData))
				return
			}
			this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.form.data)))
		},
		handleTimeChange() {
			if (!this.isNumberValid(this.form.data)) {
				this.$message.warning(`${this.comparison.comparisonName}必须为数字,且大于0`)
				this.form.data = JSON.parse(JSON.stringify(backupData))
				return
			}

			if (!this.isExpressionValid(this.form.data)) {
				this.$message.warning(this.generateMessage(this.timeVerificationRule))
				this.form.data = JSON.parse(JSON.stringify(backupData))
				return
			}
			this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.form.data)))
		},
		handleChange() {
			this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.form.data)))
		},
		handleAddClick() {
			if (this.form.data[0].userTypeId === USER_TYPE_ALL.value) {
				this.$message.warning('已经选择客户类型为"全部"')
				return
			}
			this.$emit('update:modelValue', [
				...JSON.parse(JSON.stringify(this.form.data)),
				{ selfId: this.generateId(), comparisonValue: this.alarmLevelOptions[0].value },
			])
		},
		handleDeleteClick(selfId) {
			if (this.form.data.length === 1) {
				return this.$message.warning('至少保留一项')
			}
			this.$emit(
				'update:modelValue',
				JSON.parse(JSON.stringify(this.form.data)).filter(item => item.selfId !== selfId),
			)
		},
		backUpData(data) {
			backupData = JSON.parse(JSON.stringify(data))
		},
		isNumberValid(list) {
			return !list.some(item => isNaN(item.comparisonValue) || item.comparisonValue <= 0)
		},
		isExpressionValid(list) {
			return list.every(item => isValidate(this.timeVerificationRule, Number(item.comparisonValue)))
		},
		isUserTypeRepeat(list) {
			if (list.length <= 1) {
				return true
			}
			const userTypeList = list.map(item => item.userTypeId).filter(item => item !== undefined)

			return !userTypeList.includes(USER_TYPE_ALL.value) && userTypeList.length === new Set(userTypeList).size
		},
		generateMessage(rule) {
			switch (rule.type) {
				case conditionalOptionObj.equal:
					return `${this.comparison.comparisonName}必须等于 ${rule.value}`
				case conditionalOptionObj.greater:
					return `${this.comparison.comparisonName}必须大于 ${rule.value}`
				case conditionalOptionObj.less:
					return `${this.comparison.comparisonName}必须小于 ${rule.value}`
				default:
					return `${this.comparison.comparisonName}校验出错`
			}
		},
		extractList(list) {
			return list.map(item => ({
				label: item.name,
				value: item.defaultValue,
			}))
		},
		initFormData(data) {
			return data.map(item => (item.selfId ? item : { selfId: this.generateId(), ...item }))
		},
		generateId() {
			return this.selfId++
		},
		isValid() {
			return this.form.data.every(
				item => item.userTypeId !== undefined && (!this.showComparison || item.comparisonValue !== undefined),
			)
		},
	},
}
</script>

<style scoped lang="scss">
::v-deep .el-form-item__label {
	color: #101010;
}

::v-deep .el-form-item:not(:first-child) {
	margin-left: 10px;
}

.operation-wapper {
	display: flex;
	align-items: center;
	height: 32px;

	&.disabled {
		pointer-events: none;
	}
}

.operate-icon {
	width: 18px;
	height: 18px;
	cursor: pointer;
}
</style>
